import { motion } from "framer-motion";
import { HeartHandshake, ArrowLeft, Mail } from "lucide-react";
import { LOGO_MARK, CONTACT } from "../components/site/data";

const ease = [0.16, 1, 0.3, 1];

export default function Counselling() {
  return (
    <div className="min-h-screen bg-bone text-ink flex flex-col" data-testid="counselling-page">
      <header className="max-w-[1400px] w-full mx-auto px-6 md:px-10 py-6">
        <a href="/" className="flex items-center gap-3 w-fit">
          <img src={LOGO_MARK} alt="tpj" className="h-12" />
          <span className="font-serif text-xl tracking-tight">The People's <span className="italic text-terra">Josh</span></span>
        </a>
      </header>

      <main className="flex-1 flex items-center justify-center px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease }}
          className="max-w-2xl text-center"
        >
          <span className="inline-flex w-16 h-16 items-center justify-center bg-terra/12 text-terra">
            <HeartHandshake className="w-8 h-8" strokeWidth={1.5} />
          </span>
          <p className="mt-8 text-xs tracking-[0.22em] uppercase font-semibold text-terra">Counselling Services</p>
          <h1 className="mt-4 font-serif text-5xl md:text-7xl leading-[0.95] tracking-tight">
            We're still <span className="italic text-terra">building</span> this.
          </h1>
          <p className="mt-6 text-ink/65 md:text-lg max-w-lg mx-auto">
            Our one-to-one counselling and psychological support service is on its way. In the meantime, reach out
            and we'll be glad to point you in the right direction.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href={`mailto:${CONTACT.email}`} data-testid="counselling-email"
              className="group bg-terra text-white px-8 py-4 text-sm tracking-wide flex items-center gap-3 hover:shadow-[6px_6px_0_0_#14283D] hover:-translate-x-0.5 hover:-translate-y-0.5 transition-all duration-300">
              <Mail className="w-4 h-4" /> {CONTACT.email}
            </a>
            <a href="/" data-testid="counselling-back"
              className="group border border-ink/25 px-6 py-4 text-sm tracking-wide flex items-center gap-2.5 hover:border-terra hover:text-terra transition-colors duration-300">
              <ArrowLeft className="w-4 h-4" /> Back to Education Consultancy
            </a>
          </div>
        </motion.div>
      </main>

      <footer className="max-w-[1400px] w-full mx-auto px-6 md:px-10 py-8 text-xs text-ink/40">
        © {new Date().getFullYear()} The People's Josh. All rights reserved.
      </footer>
    </div>
  );
}
